import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui";
import * as React from "react";

interface Props {
  label: string;
  selected: boolean;
  icon: LucideIcon;
  onClick: () => void;
}

export function InboxHeaderButton({ label, selected, icon, onClick }: Props) {
  const IconComponent = icon;
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className={cn(
        "text-sm font-semibold flex items-center gap-1.5 px-3 h-8 transition-all rounded-lg",
        selected
          ? "bg-indigo-50 text-primary hover:bg-indigo-100"
          : "text-slate-500 hover:text-primary hover:bg-indigo-50/50"
      )}
    >
      <IconComponent
        className={cn("size-3.5", selected ? "text-primary" : "text-slate-400 group-hover:text-primary")}
      />
      {label}
    </Button>
  );
}
